module.exports = __webpack_public_path__ + "static/color element-33-6c41b6c8ca28e1ef6d58db6b5b4bf674.png";